import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components";
import { useI18n } from "@/context";
import { useHasAnyPermission } from "@/context/permissions";

import { useTeam } from "./team.hooks";
import { RenderTeamCard } from "./team-form";

export default function TeamFormPage() {
  const hook = useTeam();
  const { t } = useI18n();
  const navigate = useNavigate();
  
  const isEditMode = Boolean(hook.userIdFromQuery);
  const hasPermission = useHasAnyPermission(
    isEditMode ? ["user:update"] : ["user:create"]
  );

  React.useEffect(() => {
    if (!hasPermission) {
      navigate("/users");
    }
  }, [hasPermission, navigate]);

  if (!hasPermission) {
    return null;
  }

  return (

    <div className="flex flex-col w-full h-full space-y-6 p-4">
      <div className="flex flex-row items-start justify-between">
        <div className="flex flex-col w-full px-2">
          <div className="flex items-center gap-3 mb-3">
            <Button
              type="button"
              variant="ghost"
              onClick={() => navigate("/users")}
              size="sm"
              className="p-3 hover:bg-muted/50 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <h1 className="text-3xl font-bold tracking-tight text-foreground">
              {isEditMode ? "Editar Usuário" : t("users.subtitle")}
            </h1>
          </div>
          
          {isEditMode && hook.currentUser ? (
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-muted-foreground">Editando o usuário:</span>
                <span className="text-sm font-semibold text-primary">
                  {hook.currentUser.first_name} {hook.currentUser.last_name}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-muted-foreground">Email:</span>
                <span className="text-sm font-semibold text-foreground">{hook.currentUser.email}</span>
              </div>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t("users.description")}
            </p>
          )}
        </div>
      </div>
            <RenderTeamCard {...hook} />
    </div>
  );
}
